import React from 'react';
import { LISTING_PAGE_PARAM_TYPE_EDIT_AND_REDIRECT } from '../../../../components/EditListingWizard/config';
import { NamedLink } from '../../../../components';
import css from './EditComponent.css';
import classNames from 'classnames';
import { IconPenM } from '../../../../icons';
/**
 * @param {Object} props
 * @param {string} props.pageName
 * @param {object} props.editParams
 * @param {string} [props.rootClassName]
 * @param {boolean} [props.hideText]
 * @param {React.ReactNode} [props.children]
 */
export default ({ pageName, rootClassName, editParams, hideText, children }) => (
    <NamedLink
        className={classNames(css.root, {
            [rootClassName]: !!rootClassName,
        })}
        name="EditListingPage"
        params={{
            ...editParams,
            type: LISTING_PAGE_PARAM_TYPE_EDIT_AND_REDIRECT,
            tab: pageName,
        }}
    >
        {children || (
            <>
                <IconPenM />
                {!hideText && (
                    <p className={css.editText}>
                        <span>Bearbeiten</span>
                    </p>
                )}
            </>
        )}
    </NamedLink>
);
